import { render, staticRenderFns } from "./NavLink.vue?vue&type=template&id=6aa4dfbe&scoped=true"
import script from "./NavLink.vue?vue&type=script&lang=ts"
export * from "./NavLink.vue?vue&type=script&lang=ts"
import style0 from "./NavLink.vue?vue&type=style&index=0&id=6aa4dfbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa4dfbe",
  null
  
)

export default component.exports